<template>
    <div class="main get-started-templates">
        <div class="scroll flex">

            <div class="inner-container" >
              <div class="">
	              <router-link to="/get-started" class="back_link_btn">
		              <inline-svg :src="require('@/assets/img/back_bt_arrow.svg')"/> Back
	              </router-link>
              <h1 >Browse templates</h1>

	              <div class="top-buttons">
		              <ul class="tab_items flex">
			              <li v-for="item in tabItems"
			                  :key="item"
			                  :class="{'active' : item === tabOpen}"
			                  @click="tabOpen=item" >
				              {{item}}
			              </li>
		              </ul>
	              </div>

	<loading v-if="loading" />

	              <div v-if="tabOpen==='All'" class="layout-column">
		              <div v-if="trendingTemplates.length>0" class="layout-column">
<!--		              <h3>Trending</h3>-->
		              <div class="templates">
			              <funnel-template-entry v-for="t in trendingTemplates" :key="t.id" :template="t"
			                                     @click="currentTemplate=t"/>
		              </div>
		              </div>
	              </div>
	              <div v-else class="layout-column">
		              <div class="templates">
			              <funnel-template-entry v-for="t in getTagTemplates(tabOpen)" :key="t.id" :template="t"
			                                     @click="currentTemplate=t"/>
		              </div>
	              </div>
              </div>
            </div>
        </div>

	    <template-panel v-if="!!currentTemplate" :template="currentTemplate" @close="currentTemplate=null" />

    </div>
</template>

<script>

import MainRight from "@/components/MainRight";
import MainSearch from "@/components/MainSearch";
import DashboardBanner from "@/components/DashboardBanner";
import VButton from "@/components/base/v-button";
import ExternalLink from "@/components/base/external-link";
import BigButton from "@/components/base/big-button";
import FunnelTemplateEntry from "@/components/funnel-template-entry";
import API from "@/api";
import TemplatePanel from "@/views/get-started/template-panel";
import AddNewFunnelPopup from "@/views/funnels/add_new_funnel_popup";
import Loading from "@/components/Loading";
export default {
    name: 'GetStartedTemplates',
	title:"Templates | Funnelish™",
    components: {
	    Loading,
	    AddNewFunnelPopup,
	    TemplatePanel,
	    FunnelTemplateEntry,
	    BigButton,
      ExternalLink,
      VButton,
      DashboardBanner,
      MainSearch,
      MainRight
    },
	mixins: [API],
	data: function() {
      return {
	      cloning: false,
	      tabOpen: 'All',
	      tabItems:['All', 'Trending', 'Popular', 'Health & Beauty', 'Gadgets', 'Leisure', 'Others'],
	      newBlankFunnel: false,
	      currentTemplate: null,
      	loading: false,
      	templates: [],
        username: "",
      }
  },
    computed: {
        notificationsOpen() {
            return this.$store.state.notificationsOpen;
        },
	    trendingTemplates(){
		    let ar = this.templates || [];
		    ar = JSON.parse(JSON.stringify(ar));
		    ar = ar.sort(function(a,b){
			    return new Date(b.created_at) - new Date(a.created_at);
		    });
		    return ar//.slice(0,5);
	    },
	    popularTemplates(){
		    let ar = this.templates || [];
		    ar = JSON.parse(JSON.stringify(ar));
		    ar = ar.sort(function(a,b){
			    return new Date(b.uses) - new Date(a.uses);
		    });
		    return ar.slice(0,5);
	    },
	    beautyTemplates(){
      	return this.getTagTemplates('health-beauty');
	    },
	    gadgetsTemplates(){
		    return this.getTagTemplates('gadgets');
	    },
	    leisureTemplates(){
		    return this.getTagTemplates('leisure');
	    },
	    otherTemplates(){
		    return this.getTagTemplates('others');
	    },
    },
    methods: {
    	getTagTemplates(tag){
		    let ar = this.templates || [];
		    tag = tag.toLowerCase();
		    tag = tag.replace('&','-').replace(/\s/g, '')
		    if (tag==='others')
			    return ar.filter(x=>['leisure','health-beauty','gadgets'].some(y => x.tags.split(',').includes(y)));
		    if (tag==='trending')
			    return this.trendingTemplates.slice(0,5);
		    if (tag==='popular')
			    return this.popularTemplates;

		    return ar.filter(x=>x.tags.split(',').includes(tag));
	    },
      openIntercom() {
	      Intercom('showNewMessage', 'Funnel Design Quote Request:\n\n' +
			      '1. How many pages you\'d like us to create?\n\n' +
			      '2. Please provide direct page(s) URLs to be cloned/redesigned?\n\n' +
			      '3. Any further details?\n');
      },
      notifToggle: function() {
          this.$store.dispatch('notificationsOpenToggle');
      },
    },
	async created() {
    	try {
    		this.loading = true;
    		this.templates = [];
		    let lst = await this.api.wsteps.getFunnelTemplates();
		    this.templates = lst.filter(x=>x.id!==1); // remove empty funnel
	    } catch (e) {
    		this.$warn(e)
	    } finally {
		    this.loading = false;
	    }
	}
}
</script>
<style lang="scss" >
.get-started-templates {
	h1 {
		margin-top: 10px;
		margin-bottom: 10px;
	}
	.top-buttons {
		display: flex;
		flex-direction: row;
		align-items: start;
		margin-top: 20px;
		.big-button {
			flex-grow: 1;
			flex-basis: 0;
			margin-right: 20px;
			&:last-child {
				margin-right: 0;
			}
		}
	}
	h2 {
		margin-top: 30px;
		font-size: 18px;
		color: $black;
	}
	.templates {
		display: grid;
		grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
		grid-gap: 20px;
		margin-top: 20px;
	}
}
</style>
<style lang="scss" >
.get-started-templates {
  .inner-container {
    padding: 30px;
  }
}

</style>
